export const statusOptions = [
  { label: 'Ativo', value: 'active' },
  { label: 'Finalizado', value: 'finalized' },
  { label: 'Cancelado', value: 'cancelled' },
  { label: 'Agendado', value: 'scheduled' },
];
